import { Guid } from '@fitscovery/common/types';
import { MembershipRequest } from '../interface';

export class ApplyForMembership {
    static readonly type = '[Membership] ApplyForMembership';

    constructor(public memberInfo: MembershipRequest) { }
}

export class ApplyForMembershipSubscription {
    static readonly type = '[Membership] ApplyForMembershipSubscription';

    constructor(public memberInfo: MembershipRequest) { }
}

export class GetMembershipsByMemberAndPartnerId {
    static readonly type = '[Membership] GetMembershipsByMemberAndPartnerId';

    constructor(public memberId: Guid, public partnerId: Guid) { }
}

export class OpenMembershipDetailsModal {
    static readonly type = '[Membership] OpenMembershipDetailsModal';

    constructor() { }
}

export class HasAccessToWorkoutOrProgram {
  static readonly type = '[Membership] HasAccessToWorkoutOrProgram';
  constructor(public selectedId: Guid) { }
}

export class RefreshMembership {
    static readonly type = '[Membership] RefreshMembership';

    constructor() { }
}
